module.exports = __webpack_public_path__ + "img/ai-search-1.b551e023.jpg";